import React, { FC } from "react";
import { Container, Card, Header } from "semantic-ui-react";
import SariaHeader from "../../components/molecules/Header";
import PictureCard from "../../PictureCard";
import listPictures from "../../ListPictures";

import { Picture } from "../../model/picture";

const Home: FC<{}> = () => {
  const pictures: Picture[] = listPictures();
  return (
    <>
      <SariaHeader></SariaHeader>
      <Container style={{ marginTop: "7em " }}>
        <Header as="h1">幸せ度チェッカー</Header>
        <Card.Group>
          {pictures.map((picture) => (
            <PictureCard
              key={picture.key}
              xid={picture.key}
              emotion={picture.emotion}
              image_url={picture.image_url}
              created_at={picture.created_at}
            ></PictureCard>
          ))}
        </Card.Group>
      </Container>
    </>
  );
};

export default Home;
